export const routeMapping: Record<string, { routePath: string; pageName: string, basePath?: string, faqCategory?: string }> = Object.freeze({
      'disputeCharge': {
        routePath: 'disputes',
        pageName: 'dispute_charge'
      },
      'payments': {
        routePath: 'payments',
        pageName: 'payments'
      },
      'makepaymentoptions': {
        routePath: 'paymentwithoptions',
        pageName: 'make_a_payment_with_options'
      },
      'autopay': {
        routePath: 'autopay',
        pageName: 'autopay'
      },
      'addpaymentsrc': {
        routePath: 'addpaymentsource',
        pageName: 'add_edit_payment_source'
      },
      'managepaymentsrc': {
        routePath: 'managepaymentsources',
        pageName: 'manage_payment_sources'
      },
      'reportlostorstolen': {
        routePath: 'lostorstolen',
        pageName: 'report_lost_or_stolen_card'
      },
      'forbearance': {
        routePath: 'forbearance',
        pageName: 'forbearance'
      },
      'onlinebillpay': {
        routePath: 'onlinebillpay',
        pageName: 'onlinebillpay'
      },
      'manageaccount': {
        routePath: 'manageaccount',
        pageName: 'manageaccount'
      },
      'signon': {
        routePath: 'signon',
        pageName: 'signon',
        basePath: 'RSauth'
      },
      'guestpay': {
        routePath: 'guestpay',
        pageName: 'guestpay',
        basePath: 'RSauth'
      },
      'verify': {
        routePath: 'registration',
        pageName: 'registration',
        basePath: 'RSenroll'
      },
      'registration': {
        routePath: 'registration',
        pageName: 'registration',
        basePath: 'RSenroll'
      },
      'linkadditionalcard': {
        routePath: 'linkadditionalcard',
        pageName: 'linkadditionalcard',
        basePath: 'RSenroll'
      },
      'ccrp': {
        routePath: 'ccrp',
        pageName: 'ccrp'
      },
      'offers': {
        routePath: 'offers',
        pageName: 'offers'
      },
      'specialoffers': {
        routePath: 'offers',
        pageName: 'offers'
      },
      'uofone': {
        routePath: 'uofone',
        pageName: 'uofone'
      },
      'obmanageapps': {
        routePath: 'obmanageapps',
        pageName: 'obmanageapps'
      },
      'balanceTransfer': {
        routePath: 'balancetransfer',
        pageName: 'balance_transfer'
      },
      'biometricEnrollment': {
        routePath: 'biometricEnroll',
        pageName: 'biometricEnrollment'
      },
      'sourceofwealth': {
        routePath: 'sourceofwealth',
        pageName: 'sourceofwealth'
      },
      'verifypaymentsource': {
        routePath: 'verifypaymentsource',
        pageName: 'verify_payment_source'
      },
      'verifypaymentsrc': {
        routePath: 'verifypaymentsource',
        pageName: 'verify_payment_source'
      },
      'statements': {
        routePath: 'statements',
        pageName: 'statements'
      },
      'reset': {
        routePath: 'fuip/fuip',
        pageName: 'fuip',
        basePath: 'RSauth'
      },
      'retrieve': {
        routePath: 'fuip/fuip',
        pageName: 'fuip',
        basePath: 'RSauth'
      },
      'newsecuremessage': {
        routePath: 'securemessage/newsecuremessage',
        pageName: 'new_message'
      },
      'managesecuremessage': {
        routePath: 'securemessage/managesecuremessage',
        pageName: 'view_reply_message'
      },
      'helpcontact': {
        routePath: 'helpcontact',
        pageName: 'helpcontact'
      },
      'addauthusers': {
        routePath: 'addauthusers',
        pageName: 'add_authorized_users'
      },
      'promodetails': {
        routePath: 'promodetails',
        pageName: 'promodetails'
      },
      'promooffers':{
        routePath: 'promodetails',
        pageName: 'promodetails'
      },
      'promoAllocation':{
        routePath: 'promoallocation',
        pageName: 'promoallocation'
      },
      'promoallocation': {
        routePath: 'promoallocation',
        pageName: 'promoallocation'
      },
      'profile': {
        routePath: 'profile',
        pageName: 'profile'
      },
      'paymentoptions': {
        routePath: 'paymentoptions',
        pageName: 'payment_options_details'
      },
      'requestreplacementcard': {
        routePath: 'requestreplacementcard',
        pageName: 'request_replacement_card'
      },
      'paperless': {
        routePath: 'paperless',
        pageName: 'paperless'
      },
      'informpayment': {
        routePath: 'informpayment',
        pageName: 'informpayment'
      },
      'citialert':{
        routePath: 'citialert',
        pageName: 'citialert'
      },
      'reportmissingpayment':{
        routePath: 'reportmissingpayment',
        pageName: 'reportmissingpayment'
      },
      'reportmissingrefund': {
        routePath: 'reportmissingrefund',
        pageName: 'reportmissingrefund'
      },
      'dashboard':{
        routePath: 'credithome',
        pageName: 'credithome'
      },
      'rewards':{
        routePath: 'rewards',
        pageName: 'rewards'
      },
      'duplicatestatement':{
        routePath: 'duplicatestatement',
        pageName: 'duplicatestatement'
      },
      'changeduedate':{
        routePath: 'changeduedate',
        pageName: 'change_due_date'
      },
      'yourstatementisready':{
        routePath: 'yourstatementisready',
        pageName: 'your_statement_is_ready'
      },
      'faqlibrary':{
        routePath: 'faqlibrary',
        pageName: 'faqlibrary',
        faqCategory: 'faqlibrary'
      },
      'sitemap':{
        routePath: 'sitemap',
        pageName: 'sitemap'
      },
      'savecard':{
        routePath: 'savecard',
        pageName: 'savecard'
      },
      'creditLineInc':{
        routePath: 'requestcreditlimitincrease',
        pageName: 'requestcreditlimitincrease'
      },
      'manageCAN':{
        routePath: 'manageCAN',
        pageName: 'manageCAN'
      },
      'ysir':{
        routePath: 'yourstatementisready',
        pageName: 'your_statement_is_ready'
      },
      'paperlessenrollment':{
        routePath: 'paperless',
        pageName: 'paperless'
      },
      'interstitial':{
        routePath: 'interstitial',
        pageName: 'interstitial'
      },
      'collections':{
        routePath: 'collections',
        pageName: 'collections'
      },
      'incomecapture': {
        routePath: 'incomecapture',
        pageName: 'incomecapture'
      }

    });
